<div class="d-flex flex-row justify-content-center w-100">
  <div class="container-fluid-960 top-spacer"></div>
</div>
<div class="container">
  <div class="row" *ngIf="results">
    <div class="col-60">
      <div class="title-container">
        <div class="d-flex flex-column w-100 justify-content-center align-items-center flex-md-row">
          <h2 class="elsa-title-font label-result">{{'label_result' | translate}}
          </h2>
          <h2 class="text-danger elsa-title-font label-result ml-md-1">{{results?.length || 0}}&nbsp;{{'label_results' | translate}}</h2>
        </div>
        <h1 class="font-weight-light label-result-2">"{{observableTerm | async}}"</h1>
      </div>
    </div>
  </div>
  <div class="row pb-5">
    <div class="col-60" *ngFor="let item of results; let first = first">
      <a [routerLink]="item.link | localize" [title]="item.title" appEmptyTitle>
        <div class="item-result" [ngClass]="{'first-item': first}">
          <img [src]="item.image" class="img-result" [alt]="item.title">
          <h4 class="title-result elsa-title-font">{{item.title}}</h4>
        </div>
      </a>
    </div>
  </div>
</div>
<div class="padding-go-up-button"></div>
